import { AutoCompleteOption } from "../components/form/APAutoComplete";
import { PaginationFilters } from "./Pagination";
import { SearchQuery } from "./Search";
import { VehicleDealer } from "./VehicleDealer";
import { APVehicleVariant } from "./Vehicles";

export type VehiclePricingRequestStatus =
  | "new"
  | "ready-to-send"
  | "awaiting-pricing"
  | "pricing-received"
  | "awaiting-procurement-invoice"
  | "procurement-invoice-sent"
  | "paid"
  | "cancelled";

export const pricingSelectedOptions: AutoCompleteOption[] = [
  { label: "Selected", id: "selected" },
  { label: "Not Selected", id: "not-selected" },
  { label: "All", id: "all" },
];

export type VehiclePricingRequestOption = {
  id: string;
  name: string;
  dealerPriceExGST: number | null;
};

export type VehiclePricingRequest = {
  id: string;
  requestIdentity: string | null;
  vehicleDealerId: string | null;
  quoteId: string | null;
  opportunityId: string | null;
  vehicleVariantId: string | null;

  requestedExteriorColour: string | null;
  requestedInteriorColour: string | null;
  noteToDealer: string | null;
  procurementFeeExGST: number | null;

  onroadPrice: number | null;
  discount: number | null;
  pricingReceivedDate: string | null;
  requestSentDate: string | null;
  alternateVehiclesETA: string | null;
  immediateDeliveryVehicles: string | null;
  availability: string | null;
  dealerNotes: string | null;

  selected: boolean;
  pricingReceived: boolean;

  vehicleVariant: APVehicleVariant | null;
  dealer: VehicleDealer | null;
  status: VehiclePricingRequestStatus;
  options: VehiclePricingRequestOption[];
};

export type VehiclePricingRequestCounts = {
  total: number;
  requested: number;
  received: number;
};

export type VehiclePricingRequestAggregations = {
  avgOnroadPrice: number;
  avgDiscount: number;
  minDiscount: number;
  maxDiscount: number;
};

type VehiclePricingRequestSearchFilterInputs = Pick<
  VehiclePricingRequest,
  "onroadPrice" | "pricingReceivedDate" | "pricingReceived"
> & {
  selected?: "selected" | "not-selected" | "all";
} & Pick<VehicleDealer, "state"> &
  Pick<APVehicleVariant, "year" | "make" | "model" | "variant">;

export type VehiclePricingRequestSearchSortOptions = Pick<
  VehiclePricingRequest,
  "onroadPrice" | "pricingReceivedDate" | "discount" | "selected"
>;

export type VehiclePricingRequestSearchFilters = PaginationFilters &
  SearchQuery<
    VehiclePricingRequestSearchFilterInputs,
    VehiclePricingRequestSearchSortOptions
  >;
